import Joi from 'joi';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getGeneralInfoDummyData } from '../../../../utils/data';

import Form from '../../../common/form';
import toastService from '../../../../services/toastService';

class AutGISystemSettingsForm extends Form {
	state = {
		data: getGeneralInfoDummyData().systemSettings,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		prf: Joi.number().required().label('PRF(KHz)'),
		eht: Joi.number().required().label('EHT (Volt)'),
		scanMode: Joi.string().min(3).required().label('Scan Mode'),
		averagingSample: Joi.number().required().label('Averaging Sample'),
		gain: Joi.string().required().label('Gain (dB)'),
		pulseWidth: Joi.number().required().label('Pulse Width (ns)'),
		digitizationRate: Joi.number().required().label('Digitization Rate (MHz)'),
		lowPassFilter: Joi.number().required().label('Low Pass Filter (MHz)'),
		highPassFilter: Joi.number().required().label('High Pass Filter (MHz)'),
		probeAngle: Joi.number().required().label('Probe Angle'),
		collectionMode: Joi.string().required().label('Collection Mode'),
		adDelay: Joi.string().required().label('A/D delay (μs)'),
		adWidth: Joi.string().required().label('A/D Width (μs)'),
	};

	static propTypes = {
		initialData: PropTypes.object,
		onProceed: PropTypes.func,
	};

	componentDidMount(): void {
		if (this.props.initialData) {
			this.setState({ data: _.omit(this.props.initialData, 'scanResolution') });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data);
		toastService.success('System settings saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">System Settings</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'prf',
							label: 'PRF(KHz)',
							placeholder: 'Enter PRF(KHz)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'eht',
							label: 'EHT (Volt)',
							placeholder: 'Enter EHT (Volt)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'gain',
							label: 'Gain (dB)',
							placeholder: 'Enter Gain (dB)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scanMode',
							label: 'Scan Mode',
							placeholder: 'Enter Scan Mode',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'averagingSample',
							label: 'Averaging Sample',
							placeholder: 'Enter Averaging Sample',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'pulseWidth',
							label: 'Pulse Width (ns)',
							placeholder: 'Enter Pulse Width (ns)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'digitizationRate',
							label: 'Digitization Rate (MHz)',
							placeholder: 'Enter Digitization Rate (MHz)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'lowPassFilter',
							label: 'Low Pass Filter (MHz)',
							placeholder: 'Enter Low Pass  Filter (MHz)',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'highPassFilter',
							label: 'High Pass Filter (MHz)',
							placeholder: 'Enter High Pass Filter (MHz)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'adDelay',
							label: 'A/D delay (μs)',
							placeholder: 'Enter A/D delay (μs)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'adWidth',
							label: 'A/D Width (μs)',
							placeholder: 'Enter A/D Width (μs)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'collectionMode',
							label: 'Collection Mode',
							placeholder: 'Enter Collection Mode',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'probeAngle',
							label: 'Probe Angle',
							placeholder: 'Enter Probe Angle',
						})}
					</div>
				</div>

				<div className="divider mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save System Settings')}
				</div>
			</form>
		);
	}
}

export default AutGISystemSettingsForm;